import * as TYPES from './type';
export default {
  [TYPES.GLOBAL_COURSE](state, { result }) {
    state.globalCourse = result.result
  },
  [TYPES.GLOBAL_CLASS](state, { result }) {
    state.globalClass = result.result
  },
  [TYPES.GLOBAL_DELFILE](state, { result }) {
    state.delFile = result.result
  },
  [TYPES.GLOBAL_TEST_DEGREE](state,result) {
    state.testSelectDegree = result
  },
  [TYPES.GLOBAL_TEST_TYPE](state,result) {
    state.testSelectType = result
  },
  [TYPES.GLOBAL_UPLOAD](state, { result }) {
    state.uploadFile = result.result
  },
  [TYPES.GLOBAL_TEST_ADD](state, { result }) {
    state.testAdd = result.result
  },
  [TYPES.GLOBAL_TEST_EDIT](state, { result }) {
    state.testEdit = result.result
  },
  [TYPES.GLOBAL_TEST_LIST](state, { result }) {
    state.testList = result.result
  },
  [TYPES.GLOBAL_DOWN_EXCEL](state, { result }) {
    state.downExcel = result.result
  },
  [TYPES.GLOBAL_TEST_DEL](state, { result }) {
    state.testDel = result.result
  },
}


// WEBPACK FOOTER //
// ./src/store/global/mutations.js